<template>
  <div class="r-image-choose common-hover" v-clickoutside="closeDimension" :style="{marginRight:marginRight}" @click="choose">
    <Tooltip v-if="config.id===3800106"  transfer max-width="400" content="Please send logo to your account manager." placement="right">
    <img class="img" v-if="config.craftPath"  v-lazy="config.craftPath" :key="config.craftPath" alt="" />
    </Tooltip>
    <img class="img" v-if="config.craftPath &&config.id!==3800106"  v-lazy="config.craftPath" :key="config.craftPath" alt="" />
    <img class="img" v-if="config.imagePath" v-lazy="config.imagePath" :key="config.imagePath" alt="" />
    <transition name="fade">
      <div class="price" v-show="showPrice&&config.price" >
        +{{config.price}}
      </div>
    </transition>
    <!-- <img class="img" @error="imgError" v-if="config.imagePath||config.craftPath" :src="config.imagePath||config.craftPath" alt="" /> -->
    <!-- <img class="img" v-else src="../assets/images/none-img.png" alt=""> -->

    <div class="name">{{ config.fabricCode || config.name || "" }}</div>
    <!-- <div>{{ config.isDefault}}</div> -->
    <div
      v-if="config.check || config.isDefault"
      class="
        r-image-box
        common-flex common-direction-column common-align-center
      "
    >
      <div class="iconfont iconwancheng"></div>
      <div v-if="boxType == 'fabric'" class="stock">
        {{ ck }}
      </div>
    </div>
    <div v-if="boxType == 'fabric'" @click.stop="previewImg" class="circle">
      <Icon type="ios-information-circle-outline" />
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: "r-image-choose",
  data() {
    return {
      ck:"",
      showPrice:false
    };
  },
  methods: {
    ...mapActions([
      "simpleGetFabricStockAction"
    ]),
    closeDimension(){
      this.showPrice = false
    },
    imgError(){
      if(this.config.imagePath){
        this.config.imagePath = ''
      }else if(this.config.craftPath){
        this.config.craftPath = ''
      }
      this.$forceUpdate()

    },
    choose() {
      this.$emit("select", this.index, this.config,this.parent);
      this.showPrice = true
      setTimeout(()=>{
         this.showPrice = false
      },3000)
    },
    previewImg() {
      this.$emit("previewImg", this.config);
    },
  },
  watch:{
    config:{
      handler(newval){
        if(this.boxType == 'fabric'&&newval.check){
          this.simpleGetFabricStockAction({
            fabricCode:newval.fabricCode
          }).then(res=>{
            this.ck = res.data
          })
        }
      },
      immediate:true,
      deep:true
    }
  },
  props: {
    index: [String, Number],
    config: [String, Object],
    parent:[String, Object],
    boxType: String,
    marginRight:{
      type:String,
      default:'4px;'
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.r-image-choose {
  // margin: 0 5px 15px;
  position: relative;
  margin-right: 4px;
  margin-bottom: 5px;
  margin-top: 5px;
  .price{
    width: 70px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    position: absolute;
    top: 54px;
    left: 2px;
    font-size: 12px;
    background: #0A4DCC;
    color: #fff;
    border-radius: 2px;
    z-index: 9999;
  }
  .stock {
    font-size: 12x;
    color: #fff;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 3px;
    // margin-bottom: 10px;
  }
  .img {
    width: 74px;
    height: 74px;
    display: block;
    border-radius: 5px;
    background: #eee;
  }
  .name {
    margin-top: 10px;
    width: 74px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .circle {
    position: absolute;
    font-size: 14px;
    color: #fff;
    top: 2px;
    right: 8px;
    z-index: 99;
  }
  .r-image-box {
    width: 78px;
    height: 78px;
    position: absolute;
    border: 1px solid #003888;
    border-radius: 5px;
    top: -2px;
    left: -2px;
    .iconwancheng {
      font-size: 24px;
      margin: auto;
      color: #003888;
      background: #fff;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-image-choose.vue